<template>
  <div class="flex-folders">
    <div class="flex-table">
      <div v-if="loading" class="text-center text-success my-2">
        <div class="spinner-border align-middle me-2" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <strong>Loading...</strong>
      </div>
      <div>
        <form class="d-flex" @submit.prevent="nullfunction">
          <Draggable
            ref="folderTree"
            v-model="nodes"
            :indent="20"
            class="w-100 he-tree"
            :default-open="false"
            :root-droppable="true"
            :each-droppable="isNodeDroppable"
            :drag-open="true"
            :drag-open-delay="300"
            @before-drag-start="onBeforeDragStart"
            @change="onDragChange"
            @enter="onDragEnter"
            @leave="onDragLeave"
            @after-drop="onAfterDrop"
          >
            <template #default="{ node, stat }">
              <div
                class="tree-node-inner d-flex align-items-center position-relative"
                :class="{
                  'drop-target-node':
                    node.data.folder_id === dropTargetFolderId,
                }"
                style="border-top: 1px solid lightgray !important"
              >
                <span
                  v-if="
                    (node.data.gdqtype === 3 || node.data.gdqtype === 0) &&
                    node.children &&
                    node.children.length > 0
                  "
                  class="toggle-icon"
                  @click="toggleNode(stat)"
                >
                  <i
                    v-if="
                      !stat.open && node.children && node.children.length > 0
                    "
                    class="fa fa-regular fa-angle-down me-2"
                  />
                  <i
                    v-if="
                      stat.open && node.children && node.children.length > 0
                    "
                    class="fa fa-regular fa-angle-up me-2"
                  />
                </span>
                <span v-else class="toggle-icon" />
                <span class="item-icon">
                  <i
                    v-if="node.data.gdqtype === 0 && node.data.folder_id === 0"
                    name="folder"
                    class="fa fa-regular fa-user"
                  />
                  <i
                    v-if="node.data.gdqtype === 0 && node.data.folder_id !== 0"
                    name="folder"
                    class="fa fa-regular fa-folder"
                  />
                  <i
                    v-if="node.data.gdqtype === 1"
                    name="folder"
                    class="fa fa-regular fa-users group-clickable"
                    @click.prevent="group_setcurrent(node.data.group_id)"
                  />
                  <fa-icon v-if="node.data.gdqtype === 3" icon="trash-alt" />
                  <fa-icon
                    v-if="node.data.gdqtype === 4"
                    icon="folder"
                    class="text-primary"
                  />
                </span>
                <!-- Type 0 = Folder -->
                <span
                  v-if="node.data.gdqtype === 0"
                  class="item-text"
                  :class="node.data.group_deleted === 1 && muteclass"
                  @click="toggleNode(stat)"
                >
                  <span
                    v-if="
                      editingnode === null ||
                      editingnode.data.folder_id !== node.data.folder_id ||
                      editingnode.data.group_id !== node.data.group_id
                    "
                  >
                    {{ node.title }}
                  </span>
                  <input
                    v-if="
                      editingnode !== null &&
                      editingnode.data.folder_id === node.data.folder_id &&
                      editingnode.data.group_id === node.data.group_id
                    "
                    :ref="'f' + node.data.folder_id"
                    v-model="editingnodename"
                    class="form-control item-input pb-0 pt-0 mt-0 mb-0"
                    placeholder="Type new name"
                    @keydown.stop
                    @keydown.esc="resetEditNode"
                    @keydown.enter.prevent="saveEditNode"
                  />
                </span>
                <!-- Type 1 = Group -->
                <span
                  v-if="node.data.gdqtype === 1"
                  class="item-text group-clickable"
                  :class="node.data.group_deleted === 1 && muteclass"
                  @click.prevent="group_setcurrent(node.data.group_id)"
                >
                  <span
                    v-if="
                      editingnode === null ||
                      editingnode.data.folder_id !== node.data.folder_id ||
                      editingnode.data.group_id !== node.data.group_id
                    "
                  >
                    {{ node.title }}
                  </span>
                  <input
                    v-if="
                      editingnode !== null &&
                      editingnode.data.folder_id === node.data.folder_id &&
                      editingnode.data.group_id === node.data.group_id
                    "
                    :ref="'g' + node.data.group_id"
                    v-model="editingnodename"
                    class="form-control item-input pb-0 pt-0 mt-0 mb-0"
                    placeholder="Type new name"
                    @keydown.stop
                    @keydown.esc="resetEditNode"
                    @keydown.enter.prevent="saveEditNode"
                  />
                </span>
                <!-- Type 3 = Trash -->
                <span
                  v-if="node.data.gdqtype === 3"
                  class="item-text"
                  @click="toggleNode(stat)"
                >
                  {{ node.title }}
                </span>
                <div
                  class="ellipsis-button d-flex align-items-center ms-auto"
                  @click.stop
                >
                  <BaseDropdown
                    v-if="
                      node.data.gdqtype === 1 &&
                      (editingnode === null ||
                        editingnode.data.folder_id !== node.data.folder_id ||
                        editingnode.data.group_id !== node.data.group_id)
                    "
                    right
                    variant="link"
                  >
                    <template #button-content>
                      <i class="fa-solid fa-ellipsis"></i>
                    </template>
                    <li>
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent="group_setcurrent(node.data.group_id)"
                        >Edit</a
                      >
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent="
                          removeNode(node.data.group_id, node.data.folder_id)
                        "
                        >Delete</a
                      >
                    </li>
                  </BaseDropdown>
                </div>
              </div>
            </template>
            <template #placeholder>
              <div class="tree-drop-placeholder">Drop here</div>
            </template>
          </Draggable>
        </form>
      </div>
    </div>
    <div v-if="!loading" class="total-show">
      <span>Showing {{ retrieved }} of {{ total }} folders</span
      ><a class="ms-3" href="/foldersgroups">Show all</a>
    </div>
    <BaseModal
      v-model="showDeleteModal"
      title="Confirm Delete"
      ok-title="Delete"
      ok-variant="danger"
      cancel-title="Cancel"
      @ok="confirmDelete"
    >
      Are you sure you want to delete this group? All surveys for this group will also be deleted.
    </BaseModal>
  </div>
</template>
<script>
import { Draggable, context as dragContext } from "@he-tree/vue";
import "@he-tree/vue/style/default.css";
import BaseModal from "../base/BaseModal.vue";
import BaseDropdown from "../base/BaseDropdown.vue";

export default {
  name: "Folders",
  components: {
    BaseModal,
    BaseDropdown,
    Draggable,
  },
  data: function () {
    return {
      allowmultiselect: false,
      addingfolder: false,
      newfoldername: "",
      muteclass: "text-muted",
      editingnode: null,
      editingnodename: "",
      addingnodeto: null,
      addingnodename: "",
      screen_id: 1,
      total: 0,
      retrieved: 0,
      screentexts: [],
      search: "",
      nodes: [],
      loading: true,
      visible: this.$store.state.mypage_folders_open,
      showDeleteModal: false,
      pendingDeleteGroupId: null,
      pendingDeleteFolderId: null,
      lastExpandedFolderId: null,
      pendingOpenFolderIds: null,
      preDragOpenFolderIds: null,
      dropTargetFolderId: null,
    };
  },
  computed: {},
  created() {
    this.groups_get();
    this.screentexts_get();
    this.set_nodes();
  },
  methods: {
    set_nodes() {
      const items = this.$store.state.foldertree.data;
      this.normalizeNodeTypes(items);
      this.total = this.$store.state.foldertree.total;
      const modifiedItems = this.restructureItems(items);
      this.setDroppableFlags(modifiedItems);
      this.nodes = modifiedItems;
      this.$nextTick(() => {
        this.closeAllNodes();
        if (this.lastExpandedFolderId !== null) {
          this.openFolderById(this.lastExpandedFolderId);
          this.lastExpandedFolderId = null;
        }
      });
    },
    isNodeDroppable(stat) {
      if (!stat || !stat.data || !stat.data.data) {
        return true;
      }
      const type = Number(stat.data.data.gdqtype);
      const canDrop = type === 0 || type === 3;
      if (canDrop) {
        console.debug("[Folders drag] droppable target detected", {
          title: stat.data.title,
          folder_id: stat.data.data.folder_id,
          gdqtype: stat.data.data.gdqtype,
        });
      }
      return canDrop;
    },
    restructureItems(items) {
      // Safety check for undefined/null items
      if (!items || !Array.isArray(items)) {
        return [];
      }

      const newTopLevelObject = {
        title: "No folder",
        data: {
          gdqtype: 0,
          folder_id: 0,
          group_id: 0,
          parent_id: 0,
        },
        children: [],
        open: false,
        isExpanded: false,
        isLeaf: false,
      };

      const modifiedItems = items.filter((item) => {
        if ((!item.children || item.children.length === 0) && item.isLeaf) {
          newTopLevelObject.children.push(item);
          return false;
        }
        return true;
      });

      modifiedItems.unshift(newTopLevelObject);

      if (modifiedItems.length === 1) {
        this.retrieved = modifiedItems.length;
        this.total = modifiedItems.length;
      } else {
        this.retrieved = modifiedItems.length - 1;
      }

      return modifiedItems;
    },
    setDroppableFlags(nodes) {
      if (!Array.isArray(nodes)) {
        return;
      }
      nodes.forEach((node) => {
        if (node && node.data) {
          const type = Number(node.data.gdqtype);
          const canDrop = type === 0 || type === 3;
          node.droppable = canDrop;
          node.data.droppable = canDrop;
          node.data.droppableDebugLabel = canDrop
            ? `droppable:${node.title}`
            : `non-droppable:${node.title}`;
        }
        if (node && Array.isArray(node.children)) {
          this.setDroppableFlags(node.children);
        }
      });
    },
    closeAllNodes() {
      const tree = this.$refs.folderTree;
      if (
        tree &&
        tree.processor &&
        typeof tree.processor.closeAll === "function"
      ) {
        tree.processor.closeAll();
      }
    },
    openFolderById(folderId) {
      const tree = this.$refs.folderTree;
      if (
        !tree ||
        !tree.processor ||
        !Array.isArray(tree.processor.statsFlat)
      ) {
        return;
      }
      const targetStat = tree.processor.statsFlat.find((stat) => {
        const d = stat.data?.data;
        return (
          d &&
          Number(d.gdqtype) === 0 &&
          Number(d.folder_id) === Number(folderId)
        );
      });
      if (targetStat) {
        tree.processor.openNodeAndParents(targetStat);
      }
    },
    getOpenFolderIds() {
      const tree = this.$refs.folderTree;
      if (!tree || !tree.processor || !Array.isArray(tree.processor.statsFlat)) {
        return [];
      }
      return tree.processor.statsFlat
        .filter((stat) => stat.open && stat.data?.data && Number(stat.data.data.gdqtype) === 0)
        .map((stat) => Number(stat.data.data.folder_id));
    },
    normalizeNodeTypes(list) {
      if (!Array.isArray(list)) {
        return;
      }
      list.forEach((node) => {
        if (node && node.data) {
          node.data.gdqtype = Number(node.data.gdqtype);
          node.data.folder_id = Number(node.data.folder_id);
          node.data.group_id = Number(node.data.group_id);
          node.data.parent_id = Number(node.data.parent_id);
        }
        if (node && Array.isArray(node.children)) {
          this.normalizeNodeTypes(node.children);
        }
      });
    },
    toggleNode(stat) {
      if (stat) {
        stat.open = !stat.open;
      }
    },
    setvisible: function () {
      this.visible = !this.visible;
      this.$store.dispatch("setfoldersopen", this.visible);
    },
    nullfunction: function () {
      return true;
    },
    nullfalse: function () {
      return false;
    },
    screentexts_get: function () {
      const screentexts = [];
      const filter = {
        screen_id: {
          operator: "=",
          value: this.screen_id,
        },
      };
      this.$store
        .dispatch("systemscreenelements_fetch", { filter })
        .then((resp) => {
          const dbtexts = resp.data.result;
          for (let i = 0; i < dbtexts.length; i++) {
            const screentext = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext,
            };
            screentexts[dbtexts[i].id] = screentext;
          }
          this.screentexts = screentexts;
        });
    },
    resetall() {
      this.addingnodeto = null;
      this.editingnode = null;
    },
    resetEditNode() {
      this.editingnode = null;
      this.editingnodename = "";
    },
    saveEditNode() {
      const node = this.editingnode;
      if (node.data.gdqtype === 0) {
        const folder = {
          id: node.data.folder_id,
          folder_name: this.editingnodename,
        };
        this.$store.dispatch("folder_save", { folder }).then(() => {
          this.editingnode = null;
          this.editingnodename = "";
          this.$store.dispatch("foldertree_fetch", { type: "new" }).then(() => {
            return false;
          });
        });
      }
      if (node.data.gdqtype === 1) {
        const group = {
          id: node.data.group_id,
          group_name: this.editingnodename,
        };
        this.$store.dispatch("group_save", { group }).then(() => {
          this.$emit("reload-dashboard");
        });
      }
    },
    removeNode(group_id, folder_id) {
      this.pendingDeleteGroupId = group_id;
      this.pendingDeleteFolderId = folder_id;
      this.showDeleteModal = true;
    },
    confirmDelete() {
      const group_id = this.pendingDeleteGroupId;
      const folder_id = this.pendingDeleteFolderId;
      const group = {
        id: group_id,
        group_folder_id: -1,
        group_deleted: 1,
      };
      const folder = {
        id: folder_id,
        parent_id: -1,
        folder_deleted: 1,
      };
      const body = {
        group,
        folder,
        type: 1,
      };
      this.$store.dispatch("treeitem_save", { id: group_id, body }).then(() => {
        this.$store.dispatch("foldertree_fetch", { type: "new" }).then(() => {
          this.removeNodeFromTree(this.nodes, group_id);
          this.$store.dispatch("mygdqpage_setreload", { reload: 1 });
          this.editingnode = null;
          this.editingnodename = "";
          this.addingnodeto = null;
          // Emit reload event after delete
          this.$emit("reload-dashboard");
        });
      });
      this.showDeleteModal = false;
      this.pendingDeleteGroupId = null;
      this.pendingDeleteFolderId = null;
    },
    removeNodeFromTree(nodes, group_id) {
      for (let i = nodes.length - 1; i >= 0; i--) {
        const node = nodes[i];
        if (node.data && node.data.group_id === group_id) {
          nodes.splice(i, 1);
        } else if (node.children && node.children.length > 0) {
          this.removeNodeFromTree(node.children, group_id);
        }
      }
    },
    getClosestDroppableStat() {
      const closest = dragContext.closestNode;
      if (closest && this.isNodeDroppable(closest)) {
        return closest;
      }
      return null;
    },
    resolveDropParentData() {
      const closest = this.getClosestDroppableStat();
      return closest ? closest.data?.data : null;
    },
    logDragContext(label, event) {
      const tgt = dragContext.targetInfo || {};
      const parent = this.resolveDropParentData();
      const closest = dragContext.closestNode
        ? dragContext.closestNode.data
        : null;
      this.dropTargetFolderId = parent ? parent.folder_id : null;
      console.log(`[Folders drag] ${label}`, {
        start: dragContext.startInfo,
        target: tgt,
        parent,
        closest,
      });
    },
    onDragEnter(event) {
      this.logDragContext("enter", event);
      const parentData = this.resolveDropParentData();
      this.dropTargetFolderId = parentData ? parentData.folder_id : null;
    },
    onDragLeave(event) {
      this.logDragContext("leave", event);
      this.dropTargetFolderId = null;
    },
    onBeforeDragStart() {
      this.preDragOpenFolderIds = this.getOpenFolderIds();
    },
    onDragChange(event) {
      this.logDragContext("change", event);
      const parentData = this.resolveDropParentData();
      this.dropTargetFolderId = parentData ? parentData.folder_id : null;
    },
    onAfterDrop() {
      this.dropTargetFolderId = null;
      const startInfo = dragContext.startInfo;
      const targetInfo = dragContext.targetInfo;
      if (!startInfo || !targetInfo || !startInfo.dragNode) {
        console.warn("[Folders drag] Missing drag context for drop action", {
          startInfo,
          targetInfo,
        });
        return;
      }

      const draggingStat = startInfo.dragNode;
      const draggingData = draggingStat.data?.data || {};
      const parentStat = targetInfo.parent;
      const parentData = parentStat ? parentStat.data?.data : null;
      const destinationType = Number(
        parentData && typeof parentData.gdqtype !== "undefined"
          ? parentData.gdqtype
          : 0
      );

      if (destinationType === 1 || destinationType === 4) {
        return;
      }

      const gdqtype = Number(draggingData.gdqtype);
      if (![0, 1].includes(gdqtype)) {
        return;
      }

      const to_folder_id =
        parentData && typeof parentData.folder_id !== "undefined"
          ? Number(parentData.folder_id)
          : 0;
      const destinationIsTrash = destinationType === 3;
      const group_deleted = destinationIsTrash ? 1 : 0;
      const folder_deleted = destinationIsTrash ? 1 : 0;
      const currentParentId =
        gdqtype === 0
          ? Number(draggingData.parent_id || 0)
          : Number(draggingData.folder_id || 0);

      if (!destinationIsTrash && currentParentId === to_folder_id) {
        return;
      }

      const body = { type: gdqtype };
      let id = null;

      if (gdqtype === 0) {
        id = draggingData.folder_id;
        if (!id) {
          console.warn(
            "[Folders drag] Missing folder id for dragged node",
            draggingData
          );
          return;
        }
        body.folder = {
          id,
          parent_id: to_folder_id,
          folder_deleted,
        };
      } else if (gdqtype === 1) {
        id = draggingData.group_id;
        if (!id) {
          console.warn(
            "[Folders drag] Missing group id for dragged node",
            draggingData
          );
          return;
        }
        body.group = {
          id,
          group_folder_id: to_folder_id,
          group_deleted,
        };
      }

      const openIds = this.preDragOpenFolderIds || [];
      if (!openIds.includes(to_folder_id)) {
        openIds.push(to_folder_id);
      }
      this.pendingOpenFolderIds = openIds;
      this.preDragOpenFolderIds = null;

      this.$store.dispatch("treeitem_save", { id, body }).then(() => {
        this.groups_get();
      });
    },
    groups_get: function () {
      this.loading = true;
      this.$store
        .dispatch("foldertree_fetch", {
          type: "new",
          search: this.search,
          drag: 1,
        })
        .then(() => {
          this.items = this.$store.state.foldertree.data;
        })
        .then(() => {
          this.normalizeNodeTypes(this.items);
          const structured = this.restructureItems(this.items);
          this.setDroppableFlags(structured);
          this.nodes = structured;
          this.$nextTick(() => {
            this.closeAllNodes();
            if (this.pendingOpenFolderIds !== null) {
              this.pendingOpenFolderIds.forEach((fid) => this.openFolderById(fid));
              this.pendingOpenFolderIds = null;
            } else if (this.lastExpandedFolderId !== null) {
              this.openFolderById(this.lastExpandedFolderId);
              this.lastExpandedFolderId = null;
            }
          });
          this.loading = false;
        });
    },
    group_setcurrent: function (group_id) {
      this.$store.dispatch("group_setcurrent", group_id);
      this.$router.push("/group");
    },
    opengroup: function () {},
  },
};
</script>
<style>
/* Override he-tree default styles to match sl-vue-tree appearance */
.he-tree {
  list-style: none;
  padding: 0;
}

.he-tree ul {
  list-style: none;
  padding-left: 0;
}

.he-tree li {
  list-style: none;
}

.tree-node-inner {
  padding: 0.35rem 0;
  cursor: pointer;
  width: 100%;
  position: relative;
  border: none !important;
}

.he-tree li + li > .tree-node-inner {
  border-top: 1px solid #dee2e6;
}

.tree-node-inner:hover {
  color: #222222;
}

.toggle-icon {
  display: inline-block;
  width: 20px;
  cursor: pointer;
  margin-right: 0.5rem;
}

.item-icon {
  display: inline-block;
  margin-right: 4px;
  font-size: 1.1em !important;
}

.item-text {
  font-size: 16px !important;
  line-height: 1em !important;
  flex: 1;
  cursor: pointer;
}

.item-input {
  font-size: 16px !important;
  line-height: 1em !important;
}

.group-clickable {
  cursor: pointer;
}

.ellipsis-button {
  margin-left: auto;
}

.ellipsis-button .btn-link {
  text-decoration: none;
  color: inherit;
  padding: 0;
}

.flex-folders :deep(.drag-placeholder),
.flex-folders :deep(.drag-placeholder-wrapper) .tree-node-inner {
  border: 1px dashed #0d6efd;
  border-radius: 6px;
  padding: 0.35rem;
  background: rgba(13, 110, 253, 0.08);
  color: #0d6efd;
  text-align: center;
  font-size: 0.85rem;
}

.drop-target-node {
  border: 1px solid #0d6efd !important;
  background: rgba(13, 110, 253, 0.06);
}

.ellipsis-button .btn-link:hover {
  text-decoration: none;
  color: inherit;
}

.ellipsis-button .btn-link:focus {
  box-shadow: none;
}

/* Hide he-tree's default fold button since we're using our own toggle */
.he-tree .tree-node-inner .fold-button {
  display: none !important;
}
-tree-divider {
  border-bottom: 1px solid #dee2e6 !important;
}
</style>
